module.exports = __webpack_public_path__ + "img/google-play@2x.32b67c37.png";